module.exports = __webpack_public_path__ + "img/tip2.06d3bfb9.png";